<template>
    <div class="card">
        <div class="card-body">
            <div class="d-md-flex align-items-center">
                <div class="col-md-6 text-left">
                    <h4 class="card-title"><i class="fas fa-credit-card"></i> Payment Terms</h4>
                </div>
                <div class="col-md-6 text-right">
                    <div class="button-group">
                        <a @click="openModal" class="btn btn-success waves-effect waves-light" data-target="#paymentTerm" data-toggle="modal" href="javasript:void(0);" v-if="status === 'DRAFT'">
                            <i class="fas fa-plus"></i> Add New
                        </a>
                        <a @click="newInvoice" class="btn btn-success waves-effect waves-light" href="javasript:void(0);" v-if="contractType === 'SALE' && status === 'CONFIRMED'">
                            <i class="fas fa-plus"></i> New Invoice
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="table-responsive" v-if="paymentTerms.length>0">
            <table class="table v-middle">
                <thead>
                <tr class="bg-light">
                    <th class="border-top-0"><h6>#</h6></th>
                    <th class="border-top-0"><h6>Type</h6></th>
                    <th class="border-top-0"><h6>Amount</h6></th>
                    <th class="border-top-0"><h6>Effective From</h6></th>
                    <th class="border-top-0"><h6>Due at</h6></th>
                    <th class="border-top-0"><h6>Frequency</h6></th>
                    <th class="border-0" v-if="status === 'DRAFT'"><h6>Action</h6></th>
                </tr>
                </thead>
                <tbody>
                <tr :class="{'selected-row': selectionNum === index}" @click="selectRow(index, pt)" style="cursor: pointer;" v-bind:key="index" v-for="(pt, index) in paymentTerms">
                    <td>{{index+1}}</td>
                    <td>{{pt.method| capitalize}}</td>
                    <td><h5 class="m-b-0">{{pt.amount | money}}</h5></td>
                    <td>{{pt.post_date | date}}</td>
                    <td>{{pt.due_date | date}}</td>
                    <td>{{pt.frequency | capitalize}}</td>
                    <td class="icon-col text-center" v-if="status === 'DRAFT'">
                        <i @click="setRemoveIndex(pt.id)" class="far fa-trash-alt text-danger" data-target="#confirmModal" data-toggle="modal" style="cursor: pointer"></i>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="card-body card-blue" v-else>
            <h4 class="card-title text-muted text-center">No records found</h4>
        </div>
        <!-- MODAL FOR CONFIRMATION -->
        <div aria-hidden="true" aria-labelledby="myModalLabel" class="modal fade" id="confirmModal" role="dialog" tabindex="-1">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-body card-blue">
                        <div class="text-center m-t-20 m-b-10">
                            <i class="fa fa-exclamation-triangle text-warning" style="font-size:50px"></i>
                            <br><br>
                            <h4>Are you sure you want to remove this payment term?</h4>
                            <button @click="removePaymentTerm(removeIndex)" class="btn waves-effect waves-light btn-success m-r-15" data-dismiss="modal" type="button">Yes</button>
                            <button class="btn waves-effect waves-light btn-danger" data-dismiss="modal" type="button">No</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- MODAL FOR ADDING PAYMENT TERMS -->
        <div aria-hidden="true" aria-labelledby="paymentTerm" class="modal fade" id="paymentTerm" role="dialog" tabindex="-1">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <form @submit.prevent="handleSubmit">
                        <div class="modal-header">
                            <h4 class="modal-title" id="myModalLabel">Payment Terms</h4>
                            <button @click="reset()" aria-hidden="true" class="close" data-dismiss="modal" type="button">×</button>
                        </div>
                        <div class="modal-body card-blue">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="ml-auto d-flex no-block align-items-center float-left">
                                            <div>
                                                <h4 class="font-medium m-b-0 text-info" v-if="contractTotal">{{contractTotal | money}}</h4>
                                                <span>Contract Amount</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="ml-auto d-flex no-block align-items-center float-right">
                                            <div>
                                                <h4 :class="{'text-danger':due.amount>0}" class="font-medium m-b-0 text-info" v-if="due">{{due | money}}</h4>
                                                <span>Amount Due</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row m-t-30">
                                    <div class="col-sm-12 col-lg-10">
                                        <div class="form-group row">
                                            <label class="col-sm-4 text-right control-label col-form-label" for="method">Select Method</label>
                                            <div class="col-sm-7">
                                                <multiselect :class="{'is-invalid': submitted && errors.has('method')}"
                                                             :options="paymentMethods"
                                                             @input="selectPaymentMethod"
                                                             class="form-control"
                                                             data-vv-as="Method"
                                                             id="method"
                                                             label="name"
                                                             name="method"
                                                             placeholder="Choose Payment Term Method"
                                                             track-by="id"
                                                             v-model="paymentTerm.method"
                                                             v-validate="'required'">
                                                    <span class="multiselect__placeholder">Type to search</span>
                                                </multiselect>
                                                <div class="invalid-feedback" v-if="submitted && errors.has('method')">{{ errors.first('method') }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-12 col-lg-10">
                                        <div class="form-group row">
                                            <label class="text-right col-sm-4 control-label col-form-label">Amount</label>
                                            <div class="input-group col-sm-7">
                                                <input :class="{'is-invalid': submitted && errors.has('amount')}"
                                                       class="form-control"
                                                       data-vv-as="amount"
                                                       id="amount"
                                                       name="amount"
                                                       placeholder="Input Amount"
                                                       style="width: 250px; height: 42px;"
                                                       type="text"
                                                       v-model="paymentTerm.amount"
                                                       v-validate="'required'">
                                                <div class="invalid-feedback" v-if="submitted && errors.has('amount')">{{ errors.first('amount') }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-12 col-lg-10">
                                        <div class="form-group row">
                                            <label class="text-right col-sm-4 control-label col-form-label" for="issue_at">Effective From</label>
                                            <div class="input-group col-sm-7">
                                                <div class="input-group-prepend date">
                                                    <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                                </div>
                                                <input :class="{'is-invalid': submitted && errors.has('issue_at')}"
                                                       autocomplete="off"
                                                       class="form-control"
                                                       data-vv-as="issue_at"
                                                       id="issue_at"
                                                       name="issue_at"
                                                       placeholder="dd/mm/yyyy"
                                                       type="text"
                                                       v-model="paymentTerm.issue_date"
                                                       v-validate="'required'">
                                                <div class="invalid-feedback" v-if="submitted && errors.has('issue_at')">{{ errors.first('issue_at') }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-12 col-lg-10">
                                        <div class="form-group row">
                                            <label class="text-right col-sm-4 control-label col-form-label" for="due_at">Due Date</label>
                                            <div class="input-group col-sm-7">
                                                <div class="input-group-prepend date">
                                                    <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                                </div>
                                                <input :class="{'is-invalid': submitted && errors.has('due_at')}"
                                                       autocomplete="off"
                                                       class="form-control"
                                                       data-vv-as="due_at"
                                                       id="due_at"
                                                       name="due_at"
                                                       placeholder="mm/dd/yyyy"
                                                       type="text"
                                                       v-model="paymentTerm.due_date"
                                                       v-validate="'required'">
                                                <div class="invalid-feedback" v-if="submitted && errors.has('due_at')">{{ errors.first('due_at') }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <template v-if="selectedPaymentMethod === 'Recurring'">
                                        <div class="col-sm-12 col-lg-10 m-t-20">
                                            <div class="form-group row">
                                                <label class="text-right col-sm-4 control-label col-form-label">Frequency</label>
                                                <div class="input-group col-sm-5">
                                                    <multiselect :allow-empty="true"
                                                                 :class="{'is-invalid': submitted && errors.has('frequency')}"
                                                                 :options="frequencies"
                                                                 class="form-control"
                                                                 data-vv-as="frequency"
                                                                 id="frequency"
                                                                 label="name"
                                                                 name="frequency"
                                                                 placeholder="Choose Period of Payment"
                                                                 track-by="id"
                                                                 v-model="paymentTerm.frequency"
                                                                 v-validate="'required'">
                                                        <span class="multiselect__placeholder">Type to search</span>
                                                    </multiselect>
                                                    <div class="invalid-feedback" v-if="submitted && errors.has('frequency')">{{ errors.first('frequency') }}</div>
                                                </div>
                                                <div class="col-sm-2" style="margin-top: 4px">
                                                    <button @click="calculateInstallment(issue_date, due_date, paymentTerm.frequency.name, paymentTerm.amount)"
                                                            class="btn btn-primary waves-effect waves-light" type="button">Calculate
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                    <div class="dataTables_scroll text-center p-l-100" style="margin-top: 45px; padding-left: 100px;" v-if="installment.length >0">
                                        <div class="dataTables_scrollHead" style="position: relative; overflow: auto; max-height: 218px; width: 100%;">
                                            <table class="table table-striped display dataTable" role="grid" style="width: 100%; margin-bottom: -1px;">
                                                <thead>
                                                <tr>
                                                    <th><h6>#</h6></th>
                                                    <th style="width: 255px;"><h6>Due Date</h6></th>
                                                    <th style="width: 245px;"><h6>Amount</h6></th>
                                                </tr>
                                                </thead>
                                            </table>
                                            <!--</div>-->
                                        </div>
                                        <div class="dataTables_scrollBody" style="position: relative; overflow: auto; max-height: 218px; width: 100%;">
                                            <table aria-describedby="scroll_ver_info" class="table table-striped display dataTable" id="scroll_ver" role="grid" style="width: 100%;">
                                                <tbody>
                                                <tr v-bind:key="index" v-for="(i, index) in installment">
                                                    <td>{{index+1}}</td>
                                                    <td style="width: 262px;">{{i.due_date | date}}</td>
                                                    <td style="width: 232px;">{{i.amount | money}}</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer button-group">
                            <button class="btn btn-success waves-effect waves-light text-white" type="submit">Add</button>
                            <a @click="reset" class="btn btn-secondary waves-effect waves-light text-white">Reset</a>
                            <button class="btn waves-effect waves-light btn-danger" data-dismiss="modal" type="button">Cancel</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <!-- MODAL FOR INVOICE GENERATE FROM RECURRING PAYMENT TERMS -->
        <div aria-hidden="true" aria-labelledby="recurringInvoice" class="modal fade" id="recurringInvoice" role="dialog" tabindex="-1">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <!--<form @submit.prevent="handleSubmit">-->
                    <div class="modal-header">
                        <h4 class="modal-title" id="recurringInvoicelLabel">Installments</h4>
                        <button @click="reset()" aria-hidden="true" class="close" data-dismiss="modal" type="button">×</button>
                    </div>
                    <div class="modal-body card-blue">
                        <div class="card-body">
                            <div class="row">
                                <div class="dataTables_scroll text-center p-l-100" style="margin-top: 45px; padding-left: 100px;" v-if="installment.length >0">
                                    <div class="dataTables_scrollHead" style="position: relative; overflow: auto; max-height: 218px; width: 100%;">
                                        <table class="table table-striped display dataTable" role="grid" style="width: 100%; margin-bottom: -1px;">
                                            <thead>
                                            <tr>
                                                <th><h6>#</h6></th>
                                                <th style="width: 255px;"><h6>Due Date</h6></th>
                                                <th style="width: 245px;"><h6>Amount</h6></th>
                                            </tr>
                                            </thead>
                                        </table>
                                        <!--</div>-->
                                    </div>
                                    <div class="dataTables_scrollBody" style="position: relative; overflow: auto; max-height: 218px; width: 100%;">
                                        <table aria-describedby="scroll_ver_info" class="table display dataTable" role="grid" style="width: 100%;">
                                            <tbody>
                                            <tr :class="{'selected-row': selectionRecInvNum === index}" @click="selectRecInvRow(index, i)" style="cursor: pointer;" v-bind:key="index"
                                                v-for="(i, index) in installment">
                                                <td>{{index+1}}</td>
                                                <td style="width: 262px;">{{i.due_date | date}}</td>
                                                <td style="width: 232px;">{{i.amount | money}}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer button-group">
                        <button @click="newRecuuringInvoice" class="btn btn-success waves-effect waves-light text-white" type="submit">Proceed</button>
                        <button class="btn waves-effect waves-light btn-danger" data-dismiss="modal" type="button">Cancel</button>
                    </div>
                    <!--</form>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Multiselect from 'vue-multiselect';
    import moment from 'moment';
    import Money from "../../../../models/Money";
    import _ from "lodash";

    export default {
        name: "PaymentTerms",
        props: {
            status: null,
            contractid: null,
            contractType: null,
            contractTotal: Object
        },
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {Multiselect},
        data() {
            return {
                paymentTermsTotal: null,
                submitted: false,
                isForward: false,
                calculated: false,
                due: null,
                paymentTerm: {
                    method: null,
                    currency_id: null,
                    amount: null,
                    issue_date: null,
                    due_date: null,
                    frequency: null
                },
                paymentTerms: [],
                issue_date: null,
                due_date: null,
                paymentMethods: [
                    {
                        id: 1,
                        name: 'Single'
                    },
                    {
                        id: 2,
                        name: 'Recurring'
                    }
                ],
                frequencies: [
                    {
                        id: 1,
                        name: 'Monthly'
                    },
                    {
                        id: 2,
                        name: 'Quarterly'
                    },
                    {
                        id: 3,
                        name: 'Yearly'
                    }],
                from: null,
                to: null,
                currency_symbol: '',
                selectedPaymentMethod: '',
                installment: [],
                removeIndex: null,
                selectionNum: -1,
                selectedPaymentTerms: null,
                selectionRecInvNum: -1,
                RecurringPaymentTerms: null
            }
        },
        mounted() {
            this.$root.$on('refreshContract', () => {
                this.init();
            })
            this.init();
        },
        methods: {
            async init() {
                this.getPaymentTerms();
                this.expressid = this.currentOrg.express_id;
            },
            async getPaymentTerms() {
                let reply         = await this.$http.get(`/express/${this.currentOrg.express_id}/contracts/${this.contractid}/paymentterms`);
                this.paymentTerms = reply.data;
            },
            async openModal() {
                this.submitted = false;
                this.reset();
                if(this.paymentTerms.length > 0) {
                    this.paymentTermsTotal = {
                        amount: _.sumBy(this.paymentTerms, 'amount.amount'),
                        currency_id: this.contractTotal.currency_id,
                        currency_name: this.contractTotal.currency_name,
                        currency_symbol: this.contractTotal.currency_symbol
                    };
                    this.due               = {
                        amount: Number(this.contractTotal.amount) - Number(this.paymentTermsTotal.amount),
                        currency_id: this.contractTotal.currency_id,
                        currency_name: this.contractTotal.currency_name,
                        currency_symbol: this.contractTotal.currency_symbol
                    };
                } else {
                    this.due = this.contractTotal;
                }
                jQuery('#issue_at').datepicker({
                    autoclose: true,
                    todayHighlight: true
                }).on('change', (event) => {
                    this.issue_date             = event.target.value;
                    this.paymentTerm.issue_date = event.target.value;
                });
                jQuery('#due_at').datepicker({
                    autoclose: true,
                    todayHighlight: true
                }).on('change', (event) => {
                    this.due_date             = event.target.value;
                    this.paymentTerm.due_date = event.target.value;
                });
            },
            selectPaymentMethod() {
                this.installment           = [];
                this.selectedPaymentMethod = this.paymentTerm.method.name;
            },
            calculateInstallment(issue_date, due_date, frequency, amount) {
                this.calculated = true;
                this.from       = moment(new Date(issue_date), 'DD/MM/YYYY');
                this.to         = moment(new Date(due_date), 'DD/MM/YYYY');
                console.log('from, to', this.from, this.to);
                this.installment = [];
                /** If Frequency Type is MONTHLY **/
                if(frequency.toUpperCase() === 'MONTHLY') {
                    let month_diff = Number(this.to.diff(this.from, "months"));
                    if(month_diff > 0) {
                        // let amount = this.paymentTerm.amount;
                        let next;
                        if(Number(this.from.format('M')) === 12) {
                            next = moment(`1/1/${Number(this.from.format('Y')) + 1}`, 'DD/MM/YYYY');
                        } else {
                            next = moment(`1/${Number(this.from.format('M')) + 1}/${this.from.year()}`, 'DD/MM/YYYY');
                        }
                        let tenure    = Math.floor(this.to.diff(this.from, 'days') / 30);
                        let remainder = amount % tenure;
                        amount -= remainder;
                        amount        = Number(amount) / Number(tenure);
                        for(let i = 0; i < tenure; i++) {
                            if(tenure - i === 1) {
                                this.installment.push({
                                    amount: {
                                        amount: amount + remainder,
                                        currency_id: this.contractTotal.currency_id,
                                        currency_name: this.contractTotal.currency_name,
                                        currency_symbol: this.contractTotal.currency_symbol
                                    },
                                    due_date: next
                                });
                            } else {
                                this.installment.push({
                                    amount: {
                                        amount: amount,
                                        currency_id: this.contractTotal.currency_id,
                                        currency_name: this.contractTotal.currency_name,
                                        currency_symbol: this.contractTotal.currency_symbol
                                    },
                                    due_date: next
                                });
                            }
                            if(Number(next.format('M')) === 12) {
                                next = moment(`1/1/${Number(next.format('Y')) + 1}`, 'DD/MM/YYYY');
                            } else {
                                next = moment(`1/${Number(next.format('M')) + 1}/${next.year()}`, 'DD/MM/YYYY');
                            }
                        }
                    } else {
                        this.$toastr('error', 'Month Difference between this two date is less than one', 'Failed');
                    }
                }
                /** If Frequency Type is QUARTERLY **/
                if(frequency.toUpperCase() === 'QUARTERLY') {
                    let month_diff = Number(this.to.diff(this.from, "months"));
                    if(month_diff > 3) {
                        // let amount = this.paymentTerm.amount;
                        let next;
                        if(Number(this.from.format('M')) === 12) {
                            next = moment(`1/3/${Number(this.from.format('Y')) + 1}`, 'DD/MM/YYYY');
                        } else {
                            next = moment(`1/${Number(this.from.format('M')) + 3}/${this.from.year()}`, 'DD/MM/YYYY');
                        }
                        let tenure    = Math.floor(this.to.diff(this.from, 'days') / 90);
                        let remainder = amount % tenure;
                        amount -= remainder;
                        amount        = Number(amount) / Number(tenure);
                        for(let i = 0; i < tenure; i++) {
                            if(tenure - i === 1) {
                                this.installment.push({
                                    amount: {
                                        amount: amount + remainder,
                                        currency_id: this.contractTotal.currency_id,
                                        currency_name: this.contractTotal.currency_name,
                                        currency_symbol: this.contractTotal.currency_symbol
                                    },
                                    due_date: next
                                });
                            } else {
                                this.installment.push({
                                    amount: {
                                        amount: amount,
                                        currency_id: this.contractTotal.currency_id,
                                        currency_name: this.contractTotal.currency_name,
                                        currency_symbol: this.contractTotal.currency_symbol
                                    },
                                    due_date: next
                                });
                            }
                            if(Number(next.format('M')) === 12) {
                                next = moment(`1/3/${Number(next.format('Y')) + 1}`, 'DD/MM/YYYY');
                            } else {
                                next = moment(`1/${Number(next.format('M')) + 3}/${next.year()}`, 'DD/MM/YYYY');
                            }
                        }
                    } else {
                        this.$toastr('error', 'Month Difference between this two date is less than three', 'Failed');
                    }
                }
                /** If Frequency Type is YEARLY **/
                if(frequency.toUpperCase() === 'YEARLY') {
                    let year_diff = Number(this.to.diff(this.from, "years"));
                    if(year_diff > 0) {
                        // let amount    = this.paymentTerm.amount;
                        let next      = moment(`1/1/${Number(this.from.format('Y')) + 1}}`, 'DD/MM/YYYY');
                        let tenure    = Math.floor(this.to.diff(this.from, 'years'));
                        let remainder = amount % tenure;
                        amount -= remainder;
                        amount        = Number(amount) / Number(tenure);
                        for(let i = 0; i < tenure; i++) {
                            if(tenure - i === 1) {
                                this.installment.push({
                                    amount: {
                                        amount: amount + remainder,
                                        currency_id: this.contractTotal.currency_id,
                                        currency_name: this.contractTotal.currency_name,
                                        currency_symbol: this.contractTotal.currency_symbol
                                    },
                                    due_date: next
                                });
                            } else {
                                this.installment.push({
                                    amount: {
                                        amount: amount,
                                        currency_id: this.contractTotal.currency_id,
                                        currency_name: this.contractTotal.currency_name,
                                        currency_symbol: this.contractTotal.currency_symbol
                                    },
                                    due_date: next
                                });
                            }
                            next = moment(`1/1/${Number(next.format('Y')) + 1}`, 'DD/MM/YYYY');
                        }
                    } else {
                        this.$toastr('error', 'Year Difference between this two date is less than one', 'Failed');
                    }
                }
            },
            async handleSubmit() {
                this.submitted = true;
                try {
                    let valid = await this.$validator.validate();
                    if(valid) {
                        this.submitted = false;
                        await this.addPaymentTerm();
                    }
                } catch(e) {
                    console.error(e);
                }
            },
            async addPaymentTerm() {
                if(this.due.amount <= 0) {
                    this.$toastr('error', 'You dont have any due amount', 'Failed');
                    return;
                }
                if(this.paymentTerms.length === 0) {
                    this.paymentTermsTotal = this.contractTotal;
                }
                let payment_term_amount = {
                    amount: this.paymentTerm.amount,
                    currency_id: this.contractTotal.currency_id,
                    currency_name: this.contractTotal.currency_name,
                    currency_symbol: this.contractTotal.currency_symbol
                };
                if(this.paymentTerms.length === 0 && new Money(payment_term_amount).gt(new Money(this.contractTotal))) {
                    this.$toastr('error', 'The added amount is greater than contract amount', 'Failed');
                    this.reset();
                    return;
                }
                if(this.paymentTerms.length > 0 && new Money(this.calculateAddedPaymentTerm(this.paymentTerms, payment_term_amount)).gt(new Money(this.contractTotal))) {
                    this.$toastr('error', 'The sum of added amounts is greater than contract amount', 'Failed');
                    this.reset();
                    return;
                }
                if(!this.calculated) {
                    this.from = moment(this.paymentTerm.issue_date, 'DD/MM/YYYY');
                    this.to   = moment(this.paymentTerm.due_date, 'DD/MM/YYYY');
                }
                let no_of_emi = 0;

                console.log(this.paymentTerm);

                if(this.paymentTerm.method.id === 2) {
                    if(this.paymentTerm.frequency.id === 1) {
                        no_of_emi      = Math.floor(this.to.diff(this.from, 'days') / 30);
                        let month_diff = Number(this.to.diff(this.from, "months"));
                        if(month_diff < 1) {
                            this.$toastr('error', 'Month Difference between this two date is less than one', 'Failed');
                            this.reset();
                            return;
                        }
                    } else if(this.paymentTerm.frequency.id === 2) {
                        no_of_emi      = Math.floor(this.to.diff(this.from, 'days') / 90);
                        let month_diff = Number(this.to.diff(this.from, "months"));
                        if(month_diff < 3) {
                            this.$toastr('error', 'Month Difference between this two date is less than three', 'Failed');
                            this.reset();
                            return;
                        }
                    } else if(this.paymentTerm.frequency.id === 3) {
                        no_of_emi     = Math.floor(this.to.diff(this.from, 'years'));
                        let year_diff = Number(this.to.diff(this.from, "years"));
                        if(year_diff < 1) {
                            this.$toastr('error', 'Year Difference between this two date is less than one', 'Failed');
                            this.reset();
                            return;
                        }
                    }
                }

                try {
                    this.paymentTerm.currency_id = this.paymentTermsTotal.currency_id;
                    this.paymentTerm.issue_date  = this.issue_date;
                    this.paymentTerm.due_date    = this.due_date;
                    await this.$http.put(`/express/${this.currentOrg.express_id}/contracts/${this.contractid}/paymentterms`, this.paymentTerm);
                    this.reset();
                    $("#paymentTerm").modal('toggle');
                    this.init();
                    this.$toastr('success', 'The Payment Term is successfully added', 'Success');
                } catch(e) {
                    this.reset();
                    $("#paymentTerm").modal('toggle');
                }
            },
            setRemoveIndex(index) {
                this.removeIndex = index
            },
            async removePaymentTerm(paymenttermsid) {
                await this.$http.delete(`/express/${this.currentOrg.express_id}/contracts/${this.contractid}/paymentterms/${paymenttermsid}`);
                this.init();
            },
            calculateAddedPaymentTerm(paymentTerms, newAmount) {
                let addedAmount = 0;
                paymentTerms.forEach(pt => {
                    addedAmount = Number(addedAmount) + Number(pt.amount.amount);
                });
                return {
                    amount: Number(addedAmount) + Number(newAmount.amount),
                    currency_id: this.contractTotal.currency_id,
                    currency_name: this.contractTotal.currency_name,
                    currency_symbol: this.contractTotal.currency_symbol
                }
            },
            reset() {
                this.submitted             = false;
                this.paymentTerm           = {
                    method: null,
                    currency_id: null,
                    amount: null,
                    issue_date: null,
                    due_date: null,
                    frequency: null
                };
                this.selectedPaymentMethod = null;
                this.installment           = [];
            },
            selectRow(index, paymentTerms) {
                if(this.selectionNum === index) {
                    this.selectionNum         = -1;
                    this.selectedPaymentTerms = null;
                } else {
                    this.selectionNum         = index;
                    this.selectedPaymentTerms = paymentTerms;
                }
            },
            async newInvoice() {
                if(!this.selectedPaymentTerms) {
                    this.$toastr('error', 'Please select a payment terms', 'Failed');
                } else {
                    if(this.selectedPaymentTerms.frequency === "ONE_TIME") {
                        await this.$http.put(`/express/${this.currentOrg.express_id}/contracts/${this.contractid}/paymentterms/${this.selectedPaymentTerms.id}/invoice`, this.selectedPaymentTerms);
                        this.$toastr('success', 'New invoice is successfully generated', 'Success');
                        this.$router.push({name: "expressinvoices"});
                    } else {
                        this.calculateInstallment(this.selectedPaymentTerms.post_date, this.selectedPaymentTerms.due_date, this.selectedPaymentTerms.frequency, this.selectedPaymentTerms.amount.amount);
                        $("#recurringInvoice").modal('toggle');
                    }
                }
            },
            selectRecInvRow(index, RecurringPaymentTerms) {
                if(this.selectionRecInvNum === index) {
                    this.selectionRecInvNum    = -1;
                    this.RecurringPaymentTerms = null;
                } else {
                    this.selectionRecInvNum    = index;
                    this.RecurringPaymentTerms = RecurringPaymentTerms;
                }
            },
            async newRecuuringInvoice() {
                if(!this.RecurringPaymentTerms) {
                    this.$toastr('error', 'Please select a payment terms', 'Failed');
                } else {
                    this.selectedPaymentTerms.amount   = this.RecurringPaymentTerms.amount;
                    this.selectedPaymentTerms.due_date = this.RecurringPaymentTerms.due_date;
                    await this.$http.put(`/express/${this.currentOrg.express_id}/contracts/${this.contractid}/paymentterms/${this.selectedPaymentTerms.id}/invoice`, this.selectedPaymentTerms);
                    $("#recurringInvoice").modal('toggle');
                    this.$toastr('success', 'New invoice is successfully generated', 'Success');
                    this.$router.push({name: "expressinvoices"});
                }
            }
        }
    }
</script>

<style scoped>
    .selected-row {
        background-color: #ccd2cb;
    }
</style>
